import dayjs from "dayjs";
import { isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import { AiFillEye } from "react-icons/ai";
import { BsArrowUpShort } from "react-icons/bs";

const Table = ({ transactions, page, sort, setSort, handleTransactionDetailsView }) => {
  const { t } = useTranslation();
  return (
    <div className="p-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6">
                #
              </th>
              <th scope="col" className="py-3 px-6">
                {t("TRANSACTION_ID")}
              </th>
              <th scope="col" className="py-3 px-6 text-left">
                {t("TRANSACTION_TRANSACTION_ACTIVITY")}
              </th>
              <th scope="col" className="py-3 px-6 text-left">
                {t("TRANSACTION_AMOUNT")}
              </th>
              <th scope="col" className="py-3 px-6 text-left">
                {t("INITIATED_BY")}
              </th>
              <th scope="col" className="py-3 px-6 text-left">
                {t("PARTICIPANTS")}
              </th>
              <th scope="col" className="py-3 px-6 text-left">
                {t("O_STATUS")}
              </th>
              <th
                scope="col"
                className="py-3 px-6 cursor-pointer "
                onClick={() => {
                  if (sort.sort_key === "createdAt" && sort.sort_type === "asc") {
                    setSort({
                      sort_key: "createdAt",
                      sort_type: "desc",
                    });
                  } else {
                    setSort({
                      sort_key: "createdAt",
                      sort_type: "asc",
                    });
                  }
                }}
              >
                <div className="flex justify-start">
                  <span>{t("O_CREATED_AT")}</span>
                  <span>
                    {sort.sort_key === "createdAt" && sort.sort_type === "asc" && <BsArrowUpShort className="w-4 h-4" />}
                    {sort.sort_key === "createdAt" && sort.sort_type === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
                  </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-6 text-left">
                {t("O_DETAILS")}
              </th>
            </tr>
          </thead>
          <tbody>
            {transactions &&
              transactions?.map((item, i) => (
                <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className="py-4 px-6 border-r">{item?.transaction_id}</td>
                  <td className="py-4 px-6 border-r">{item?.transaction_type}</td>
                  <td className="py-4 px-6 border-r text-right">{item?.total_amount?.toFixed(2)} {item.currency}</td>
                  <td className="py-4 px-6 border-r">
                    {item?.initiatorData
                      ? item?.initiatorData.businessName
                        ? item.initiatorData.businessName
                        : `${item?.initiatorData.first_name} ${item.initiatorData.last_name} ${
                            item.initiatorData.userType === "user" ? `(${item.initiatorData.username})` : `[${item.initiatorData.userType}]`
                          }`
                      : "-"}
                  </td>
                  <td className="py-4 px-6 border-r">
                    {item?.participants.length === 0
                      ? "-"
                      : item?.participants
                          .reduce((accumulator, current) => {
                            if (!accumulator.some((item) => item._id === current._id)) {
                              accumulator.push(current);
                            }
                            return accumulator;
                          }, [])
                          .map((curr) => (curr.businessName ? curr.businessName : `${curr.first_name} ${curr.last_name} ${curr.userType === "user" ? `(${curr.username})` : `[${curr.userType}]`}`))
                          .join(", ")}
                  </td>{" "}
                  <td className="py-4 px-6 border-r">{t(item?.status)}</td>
                  <td className="py-4 px-6 border-r">{dayjs(item?.createdAt).format("DD-MM-YYYY hh:mm A")}</td>
                  <td className="py-4 px-6 border-r">
                    <div className="">
                      <ul className="flex justify-center">
                        <li onClick={() => handleTransactionDetailsView(item)} className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                          <a title={t("O_DETAILS")}>
                            {" "}
                            <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(transactions) ? (
              <tr className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6 border-r" colSpan={9}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
